import React from 'react'
import { useTranslation } from "react-i18next";
import "../../../styles/global.css";
import { Image } from "react-bootstrap";
import { Link } from "react-router-dom";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import udyami_launchpad_logo from "../../../assets/images/udyami-launchpad-logo.png";
import SD_logo from "../../../assets/images/samadhan-horizontal-logo.png";
import Styles from "../../../styles/Modules/ProjectReport.module.css";
import { faFacebook, faInstagram, faLinkedinIn, faTwitter, faYoutube } from '@fortawesome/free-brands-svg-icons';
import { BiSupport } from 'react-icons/bi';



export default function Footer() {
    const { t } = useTranslation();
    return (
        <footer className="bg-white">
            {/* <div className="first-footer bg-gradient-style">
                <div className="container ">
                    <div
                        className={`d-flex align-items-center justify-content-between ${Styles.widget_container}`}
                    >
                        <div className="widget-area me-auto">
                            <div className="d-flex align-items-center">
                                <span className={`me-3 mb-2 ${Styles.support_icon}`}>
                                    {" "}
                                    <BiSupport className="text-white" />
                                </span>
                                <div className="featured-content">
                                    <h5 className="text-white">Customer Support</h5>
                                    <p className="my-0 text-white">
                                        We are available 24X7 for grievance redressal
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div>
                            <button className="btn btn-primary btn-small btn-theme fs-6">
                                <Link >
                                    <p href="https://msme.cmyuva.org.in/support">Connect</p>
                                </Link></button>
                        </div>
                    </div>
                </div>
            </div> */}
            <div className="footer-supplier">
                <div className="container py-3 pt-4 pb-0">
                    <div className="row">
                        {/* <div className="col-md-5 bg-info">
                            <div className="mb-3">
                                <Image
                                    src={udyami_launchpad_logo}
                                    width="250"
                                    alt="image not found"
                                />
                            </div>
                        </div> */}
                        <div className="col-12 d-flex justify-content-center justify-content-md-start ">
                            <div className="mb-3">
                                <span className="d-block mb-1 text-secondary text-end">Knowledge Partner</span>
                                <Image
                                    src={SD_logo}
                                    width="160"
                                    alt="image not found"
                                />
                            </div>
                        </div>
                        <div className="col-md-12 border-top py-2">
                            <div className="row justify-content-between">
                                <div className="col-md-5 col-12 d-flex flex-column align-items-center align-items-md-start mb-4">
                                    <h6 className="fw-bold mb-3">Contact</h6>
                                    <span className="d-block mb-1 text-secondary">
                                        We are happy to help you. Raise your query at our customer
                                        helpdesk
                                    </span>
                                    <strong><a href="tel:+919129987111">+91 9129-9871-11</a></strong><strong><a href="tel:0522-690-5555">0522-690-5555</a></strong><br />
                                    <strong><a href="mailto:cmyuva.msme@gmail.com">cmyuva.msme@gmail.com</a></strong>
                                </div>
                                <div className="col-md-2 col-4">
                                    <h6 className="fw-bold mb-3">Ideation</h6>
                                    <div className="mt-2">
                                       
                                            <a href="https://cmyuva.org.in/ideation/industrial-documentries" className="text-secondary fw-medium">
                                                {" "}
                                                Industrial Documentries
                                            </a>
                                        
                                    </div>
                                    <div className="mt-2">
                                       
                                            <a href="https://cmyuva.org.in/ideation/project-report" className="text-secondary fw-medium">Project Report</a>
                                        
                                    </div>
                                    <div className="mt-2">
                                       
                                            <a href="https://cmyuva.org.in/ideation/expert-talks" className="text-secondary fw-medium">
                                                Expert Talk
                                            </a>
                                        
                                    </div>
                                    <div className="mt-2">
                                       
                                            <a href="https://cmyuva.org.in/ideation/supplier-connect" className="text-secondary fw-medium">Supplier Connect</a>
                                       
                                    </div>
                                </div>
                                <div className="col-md-2 col-4">
                                    <h6 className="fw-bold mb-3">Incubation</h6>
                                    <div className="mt-2">
                                        
                                            <a href="https://cmyuva.org.in/services/gst" className="text-secondary fw-medium">Gst</a>
                                        
                                    </div>
                                    <div className="mt-2">
                                       
                                            <a href="https://cmyuva.org.in/services/udyam" className="text-secondary fw-medium">Udyam</a>
                                        
                                    </div>
                                    <div className="mt-2">
                                        
                                            <a href="https://cmyuva.org.in/customize-bankable-report" className="text-secondary fw-medium">Bankable Project Report</a>
                                       
                                    </div>
                                   

                                </div>
                                <div className="col-md-2 col-4">
                                    <h6 className="fw-bold mb-3">Nurturing</h6>
                                    <div className="mt-2">
                                       
                                            <a href="https://cmyuva.org.in/workshop" className="text-secondary fw-medium">Business Pathshala </a>
                                       
                                    </div>
                                    <div className="mt-2">
                                        
                                            <a href="https://cmyuva.org.in/ideation/expert-talks" className="text-secondary fw-medium">Expert Talk</a>
                                        
                                    </div>

                                    <div className="mt-2">
                                        
                                            <a href="https://msme.cmyuva.org.in/all-workshop" passHref
                                                className="text-secondary fw-medium"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            >
                                                Webinar & workshop
                                            </a>
                                       
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                    <div className="row">
                        <div className="border-top d-flex justify-content-between mt-2 py-2 px-0">
                            <small className="text-secondary">
                                Copyright © 1999-2025 Samadhan Group. All Rights Reserved.
                            </small>
                            <div className="social-links">
                                <a
                                    href={"https://www.facebook.com/share/1JxeyhSgpA/"}
                                    target="_blank"
                                    className="social-links-items"
                                >
                                    <FontAwesomeIcon icon={faFacebook} />
                                </a>
                                <a
                                    href={"https://www.instagram.com/cm_yuva?igsh=MTN4b2ZoaWF5YXoydg=="}
                                    target="_blank"
                                    className="social-links-items"
                                >
                                    <FontAwesomeIcon icon={faInstagram} />
                                </a>
                                <a
                                    href={"https://youtube.com/@cmyuva?si=OMaz8zvUUGKoIOWv"}
                                    target="_blank"
                                    className="social-links-items"
                                >
                                    <FontAwesomeIcon icon={faYoutube} />
                                </a>
                                <a
                                    href={"https://x.com/cm_yuva"}
                                    target="_blank"
                                    className="social-links-items"
                                >
                                    <FontAwesomeIcon icon={faTwitter} />
                                </a>
                                <a
                                    href={"https://www.linkedin.com/company/cmyuva/"}
                                    target="_blank"
                                    className="social-links-items"
                                >
                                    <FontAwesomeIcon icon={faLinkedinIn} />
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
}